import React, { Component } from "react";
import CartActions from "../containers/CartActions";
import ProductPrice from "./ProductPrice";
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";
import { withTranslation } from 'react-i18next';

class ProductCard extends Component {


    onProductClick(id) {
        const { product, settings, listName, listId } = this.props;
                if (window.gtag) {
                    window.gtag('event', 'select_item', {
                        currency: settings.isoCurrencySymbol,
                        items: [{
                            item_id: product.stockItemCode,
                            item_name: product.title,
                            item_category: product.groupName,
                            price: product.specialPrice,
                            currency: settings.isoCurrencySymbol,
                            quantity: this.state.quantity
                        }],
                        value: product.specialPrice,
                        item_list_name: listName,
                        item_list_id: listId
                    });
                }
    }

    render() {
        const { product, settings, className } = this.props;
    if (!product) return <div />;
      const productLink = `${settings.baseUrl}products/${product.id}`;
      const { specialPrice } = product;
      const showOpenPay = settings.isOpenpayEnabled === true && settings.showBadgeOnProductPages && specialPrice > settings.openpayMinLimit && specialPrice < settings.openpayMaxLimit;

        return this.props.isHorizontal ? (
            <div className="product-card product-list">
                <a className="product-thumb" onClick={this.onProductClick.bind(this)} href={productLink}>
                    <Image src={product.thumbnail ? product.thumbnail : "img/no-image.jpg"}
                        fallbackSrc="img/no-image.jpg" alt={product.title} />
                </a>
                <div className="product-info">
                    <h3 className="product-title">
                        <ExtendedLink to={productLink} title={product.title}>
                            {product.title}
                        </ExtendedLink>
                    </h3>
                    <ProductPrice product={product} settings={settings} />
                    <p className="hidden-xs-down">{product.description}</p>
                    <CartActions product={product} />
                </div>
            </div>
        ) : (
                <div className={className}>
          <div className="product-card">
            {/* <div className="product-badge text-danger">50% Off</div> */}
                    <ExtendedLink to={productLink} className="product-thumb">
                        <Image src={product.thumbnail ? product.thumbnail : "img/no-image.jpg"}
                            fallbackSrc="img/no-image.jpg" alt={product.title} />
            </ExtendedLink>
            <h3 className="product-title">
              <ExtendedLink to={productLink} title={product.title}>
                {product.title}
              </ExtendedLink>
            </h3>
                    <ProductPrice product={product} settings={settings} />
                    {showOpenPay && <div className='text-center'> <opy-product-listing amount={specialPrice} logo-position="right"></opy-product-listing> </div>}
            <CartActions product={product} />
          </div>
        </div>
      );
  }
}

export default withTranslation()(ProductCard);
